// extracted by mini-css-extract-plugin
module.exports = {"metricSelector":"styles_metricSelector__24p5f"};